<template>
  <div class="bg-zinc-300 flex-grow">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
